// extracted by mini-css-extract-plugin
module.exports = {"card":"insuranceCard_card__V6YXG","image":"insuranceCard_image__zamXr"};